import { CONSTANTS } from '../constants/constants';

export const parseTasksFromSOW = (sowContent, t) => {
  let tasks = [];
  
  try {
    const jsonData = JSON.parse(sowContent);
    if (Array.isArray(jsonData)) {
      tasks = jsonData.map((item, index) => ({
        id: index + 1,
        // Store the data needed to generate the JSX later
        taskData: item,
        description: item.description, // Store the raw description
        paused: false,
        completed: item.completed || false,
        timeSpent: item.timeSpent || 0,
        status: item.status || CONSTANTS.STATUS.NOT_STARTED,
        startTime: item.startTime || null,
        endTime: item.endTime || null,
        location: null,
        submitted: item.submitted
      }));
    }
  } catch (e) {
    // If not JSON, parse as HTML/text (keep this part the same)
    const parser = new DOMParser();
    const doc = parser.parseFromString(sowContent, 'text/html');
    const textContent = doc.body.textContent || '';
    
    const lines = textContent.split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);
    
    tasks = lines.map((line, index) => ({
      id: index + 2,
      description: line.replace(/^\d+\.\s*/, '').replace(/^-\s*/, ''),
      taskData: { description: line.replace(/^\d+\.\s*/, '').replace(/^-\s*/, '') },
      completed: false,
      timeSpent: 0,
      status: CONSTANTS.STATUS.NOT_STARTED,
      startTime: null,
      endTime: null,
      location: null,
      submitted: false
    }));
  }

  // Add travel tasks if we have any parsed tasks
  if (tasks.length > 0) {
    // Add "Travel to customer site" at the beginning
    const travelToTask = {
      id: 0,
      description: t('travelToCustomer'),
      taskData: { description: t('travelToCustomer') },
      completed: false,
      timeSpent: 0,
      status: CONSTANTS.STATUS.NOT_STARTED,
      startTime: null,
      endTime: null,
      location: null,
      submitted: false,
      paused: false,
      key: CONSTANTS.KEYS.TRAVEL_TO
    };
    
    // Add "Security check" task
    const securityCheck = {
      id: 1,
      description: t('securityCheck'),
      taskData: { description: t('securityCheck') },
      completed: false,
      timeSpent: 0,
      status: CONSTANTS.STATUS.NOT_STARTED,
      startTime: null,
      endTime: null,
      location: null,
      submitted: false,
      paused: false,
      key: CONSTANTS.KEYS.SECURITY_CHECK
    };
    
    // Add "Customer QA" task
    const customerQATask = {
      id: tasks.length + 2,
      description: t('customerQA'),
      taskData: { description: t('customerQA') },
      completed: false,
      timeSpent: 0,
      status: CONSTANTS.STATUS.NOT_STARTED,
      startTime: null,
      endTime: null,
      location: null,
      submitted: false,
      paused: false,
      key: CONSTANTS.KEYS.CUSTOMER_QA
    };
    // Add "Travel from customer site" at the end
    const travelFromTask = {
      id: tasks.length + 3,
      description: t('travelFromCustomer'),
      taskData: { description: t('travelFromCustomer') },
      completed: false,
      timeSpent: 0,
      status: CONSTANTS.STATUS.NOT_STARTED,
      startTime: null,
      endTime: null,
      location: null,
      submitted: false,
      paused: false,
      key: CONSTANTS.KEYS.TRAVEL_FROM
    };

    // Reassign IDs to maintain sequential order
    const allTasks = [travelToTask, securityCheck, ...tasks, customerQATask, travelFromTask];
    
    return allTasks.map((task, index) => ({
      ...task,
      id: index + 1
    }));
  }

  return [];
};